import type { SaleItemEntity } from '~/types/sale.type';

type UseTrustReportReturn = {
    isTrustReportEligible: ComputedRef<boolean>;
};

export const useTrustReport = (sale: MaybeRefOrGetter<Pick<SaleItemEntity, 'type'>>): UseTrustReportReturn => {
    const { isToBeScraped } = useSaleType(() => toValue(sale).type);

    return {
        isTrustReportEligible: computed(() => !isToBeScraped.value),
    };
};
